import React, { useState } from "react"
import PropTypes from "prop-types"
import tw, { styled as twStyled } from "twin.macro"
import OffClick from "react-offclick"

import { ChevronDown } from "react-feather"

export const isPartiallyActive = ({ isPartiallyCurrent }) => {
  return isPartiallyCurrent ? { className: "nav__link is-active" } : null
}

export const Link = ({ link, subtree, elem, ...props }) => {
  let Elem = elem
  //link.url = remove ? link.url.replace(`${remove}/`, '') : link.url;
  //link.url = link.url.replace(`${remove}/`, '');
  if (link.url.includes("force.com") || link.url === "/join") {
    Elem = (props) => <a {...props} href={link.url} />
  }

  return (
    <Elem to={link.url} {...props} getProps={isPartiallyActive}>
      {link.title}{" "}
      {subtree?.length > 0 && (
        <span className="material-icons material-icons-round">expand_more</span>
      )}
    </Elem>
  )
}

const Navigation = ({ items, linkElement, tree, remove }) => {
  const Elem = linkElement
  const [active, setActive] = useState(null)

  return (
    <Style className="nav">
      <OffClick handler={() => setActive(null)}>
        <Menu className="nav__menu">
          {tree.map((item, i) => (
            <li key={i}>
              {/*<Link
                            {...item}
                            elem={linkElement}
                            className="nav__link"
                            getProps={isPartiallyActive}
                />*/}
              {item?.subtree.length > 0 ? (
                <>
                  <button
                    type="button"
                    aria-selected={item.link.url === active}
                    className="nav__link nav__link-toggle"
                    onClick={() =>
                      setActive(item.link.url === active ? null : item.link.url)
                    }
                  >
                    {item.link.title}
                    <ChevronDown aria-hidden="true" />
                  </button>
                  <ul
                    className="nav__dropdown"
                    aria-hidden={item.link.url !== active}
                  >
                    {item.subtree.map((sub, x) => (
                      <li key={x}>
                        <Link
                          {...sub}
                          subtree={[]}
                          elem={linkElement}
                          className="nav__sub-link"
                          activeClassName="is-active"
                        />
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <Link
                  {...item}
                  elem={linkElement}
                  className="nav__link"
                  getProps={isPartiallyActive}
                />
              )}
            </li>
          ))}
        </Menu>
      </OffClick>
    </Style>
  )
}

export default Navigation

Navigation.propTypes = {
  items: PropTypes.array,
  tree: PropTypes.array,
  remove: PropTypes.string,
}
Navigation.defaultProps = {
  linkElement: React.createElement("span"),
}

const Style = twStyled.nav`
    ${tw`h-full`}
`

const Menu = twStyled.ul`
    ${tw`
        list-none
        h-full
        justify-end hidden
        lg:portrait:hidden
        lg:flex
        items-center
        p-0
        m-0
        fontSize[18px]
        gap-x-4
        xl:fontSize[calc(.75em + .5vmax)]
        mg:fontSize[calc(.75em + .65vmax)]
        md:gap-x-4
        lg:gap-x-5
        xl:gap-x-8
    `}

    li {
        &[data-section] {
            ${tw`hidden!`}
        }

        [data-section="Residential"] &[data-section="Residential"],
        [data-section="Business"] &[data-section="Business"] {
            ${tw`block!`}
        }
    }

    > li {
        ${tw`m-0 block relative`}
        white-space: nowrap;

        > .nav__dropdown {
            ${tw`hidden absolute z-10 bg-white list-none m-0 min-w-full divide-y divide-gray-200 minWidth[250px]`}
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;

            a {
                ${tw`line-clamp-2 whitespace-normal`}
            }
        }

        .nav__dropdown[aria-hidden="false"],
        .nav__link:focus-visible + .nav__dropdown,
        .nav__dropdown:focus-within {
            ${tw`block`}
        }




    }



    button.nav__link, a {
        ${tw`block overflow-hidden cursor-pointer no-underline fontWeight[600] color[var(--nova-default)] `}
    }
    button.nav__link-toggle {
        ${tw`flex items-center gap-2`}

        &[aria-selected="true"] svg {
            ${tw`transform rotate-180`}
        }
    }

    .nav__link {
        ${tw`flex items-center h-full hover:text-primary`}

        @media (pointer: coarse) {
            svg {
                ${tw`hidden`}
            }
        }

        &::after {
            height: 7px;
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            transition: transform .15s ease-in-out;
            transform: translateY(100%);
            ${tw`bg-primary`}
        }

        &.is-active::after {
            transform: translateY(0);
        }

        &:focus-visible {
            outline: none;
            color: var(--nova-orange);
        }

        &.is-active {
            ${tw`text-primary`}
        }
    }

    .nav__special-link {
        ${tw`flex items-center`}
    }

    .nav__dropdown {
        ${tw`pt-2`}
    }

    .nav__dropdown > li {
        ${tw`m-0 block min-h-full relative`}

        .is-active::after {
            content: none;
        }
    }

    .nav__dropdown a {
        ${tw`leading-tight fontSize[15px] xl:fontSize[calc(.75em + .225vmax)] p-2 hover:text-dark focus-visible:text-orange outline-none focus-visible:bg-orange focus-visible:bg-opacity-20`}

        &.is-active {
            ${tw`text-primary`}
        }
    }
`
